import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getWeather } from '../../../actions/weather';

const View = (props) => {
  const { data = {} } = props;
  const location = data.location || 'Helsinki, Finland';

  // API im Backend
  const dispatch = useDispatch();
  const weatherData = useSelector((state) => state.weather?.data);
  // End API im Backend

  const getTemperatureColor = (temp) => {
    if (temp <= 0) return '#4B9FE1'; // Cold blue
    if (temp <= 10) return '#84CEF1'; // Cool blue
    if (temp <= 20) return '#F7B267'; // Warm orange
    return '#FF6B6B'; // Hot red
  };
  const getTemperatureHeight = (temp) => {
    // Normalize temperature to a reasonable bar height
    const baseHeight = 30; // minimum height
    const scale = 2; // multiplier for each degree
    return baseHeight + (temp + 10) * scale; // +10 to handle negative temps
  };
  useEffect(() => {
    dispatch(getWeather(data.latitude, data.longitude));
  }, [dispatch, data.latitude, data.longitude]);

  return (
    <>
      {weatherData ? (
        <div className="weather-block">
          <h2>Weather Forecast for {location}</h2>
          <div className="date">
            {new Date(weatherData?.hourly?.time?.[0]).toLocaleDateString(
              'en-US',
              {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              },
            )}
          </div>

          {/* Temperature Section */}
          <h3>Temperature Forecast</h3>
          <div className="temperature-legend">
            <div className="legend-item">
              <span
                className="legend-color"
                style={{ backgroundColor: '#4B9FE1' }}
              ></span>
              <span className="legend-text">Cold (≤ 0°C)</span>
            </div>
            <div className="legend-item">
              <span
                className="legend-color"
                style={{ backgroundColor: '#84CEF1' }}
              ></span>
              <span className="legend-text">Cool (1-10°C)</span>
            </div>
            <div className="legend-item">
              <span
                className="legend-color"
                style={{ backgroundColor: '#F7B267' }}
              ></span>
              <span className="legend-text">Warm (11-20°C)</span>
            </div>
            <div className="legend-item">
              <span
                className="legend-color"
                style={{ backgroundColor: '#FF6B6B' }}
              ></span>
              <span className="legend-text">Hot (&gt;20°C)</span>
            </div>
          </div>
          <div className="hourly-forecast temperature-forecast">
            {weatherData?.hourly?.time?.map((time, index) => {
              const hour = new Date(time).getHours();
              const temperature = weatherData?.hourly?.temperature_2m?.[index];
              if (temperature == null) return null;
              return (
                <div key={time} className="hourly-item">
                  <div className="hour">{hour}:00</div>

                  <div className="temperature-container">
                    <div
                      className="temperature-bar"
                      style={{
                        height: `${getTemperatureHeight(temperature)}px`,
                        backgroundColor: getTemperatureColor(temperature),
                      }}
                    >
                      <span className="temperature-tooltip">
                        {temperature.toFixed(1)}°C
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          {/* Precipitation Section */}
          <h3>Precipitation Forecast</h3>
          <div className="hourly-forecast">
            {weatherData?.hourly?.time?.map((time, index) => {
              const hour = new Date(time).getHours();
              const probability =
                weatherData?.hourly?.precipitation_probability?.[index] ?? 0;
              return (
                <div key={time} className="hourly-item">
                  <div className="hour">{hour}:00</div>
                  <div className="probability">
                    <div
                      className="probability-bar"
                      style={{
                        height: `${probability}%`,
                        backgroundColor: `rgba(0, 0, 255, ${probability / 100})`,
                      }}
                    />
                  </div>
                  <div className="probability-value">{probability}%</div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <p>Loading weather data...</p>
      )}
    </>
  );
};

export default View;
